import { SimpleAnalyticsUpdatePayload } from '@/types/SimpleAnalytics';
import type { WeekStart } from '@/i18n/weekStart';
import { apiGetRequest, apiPutRequest } from '@/utils/apiClient';

type FetchSimpleAnalyticsOptions = {
    startDate?: string;
    endDate?: string;
    weekStartsOn?: WeekStart;
    etag?: string;
};

// シンプル分析データを取得する
export const fetchSimpleAnalytics = async (options: FetchSimpleAnalyticsOptions = {}) => {
    const { startDate, endDate, weekStartsOn, etag } = options;
    const headers = etag ? { 'If-None-Match': etag } : undefined;
    const params = new URLSearchParams();
    if (startDate && endDate) {
        params.set('startDate', startDate);
        params.set('endDate', endDate);
    }
    if (weekStartsOn) {
        params.set('weekStartsOn', weekStartsOn);
    }
    const query = params.toString();
    const url = `/api/simple-analytics${query ? `?${query}` : ''}`;
    return await apiGetRequest(url, headers);
};

// シンプル分析データを更新する
export const updateSimpleAnalytics = async (payload: SimpleAnalyticsUpdatePayload) => {
    return await apiPutRequest('/api/simple-analytics', payload);
};
